export default "__VITE_ASSET__DFQ2$JUb__"